<template>
    <video
        ref="video"
        :id="id"
        class="video-js"
        controls
    ></video>
</template>
<script>
// import "video.js/dist/video-js.css";
import "./video-js-custom.less";
// import VideoJS from "expose-loader?videojs!video.js";
import VideoJS from "video.js";
import VideoJS_ZH from "video.js/dist/lang/zh-CN.json";
// import Flvjs from "expose-loader?flvjs!flv.js/dist/flv.min";
import "expose-loader?Flvjs!./flv-1.5.0";
import "./videojs-flvjs";
import "./cd-poster";
// console.log(Flvjs)

export default {
    props: {
        poster: {
            type: String,
        },
        src: {
            type: String,
            required: true,
        },
        playing: { type: Boolean, default: true },
        width: { type: Number, default: 592 },
        height: { type: Number, default: 333 },
        cdPoster: { type: Boolean, default: false },
        volume: {
            type: Number,
            validator: (val) => val >= 0 && val <= 1,
            default: 1,
        },
        noPlayBtn: {
            type: Boolean,
            default: false,
        },
        preload: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            id: ("videojs_" + Math.random()).replace(".", ""),
            player: null,
            needUpdateSrc: false,
        };
    },
    watch: {
        src: function (newVal) {
            if(this.playing || this.preload) {
                this.setSrc(newVal);
            } else {
                this.needUpdateSrc = true;
            }
            setTimeout(() => {
                if (this.playing) {
                    this.player.play();
                } else {
                    this.player.pause();
                }
            });
        },
        poster: function (newVal) {
            this.player.poster(newVal);
        },
        playing: function (newVal) {
            if(this.needUpdateSrc) {
                this.setSrc(this.src);
                this.needUpdateSrc = false
            }
            setTimeout(() => {
                if (this.playing) {
                    this.player.play();
                } else {
                    this.player.pause();
                }
            });
        },
        volume: function (newVal) {
            this.player.volume(newVal);
        },
        width: function (newVal) {
            this.player.width(newVal);
        },
        height: function (newVal) {
            this.player.height(newVal);
        },
        cdPoster: function (newVal) {
            if (newVal) {
                if (!this.player.getChild("CDPoster"))
                    this.player.addChild("CDPoster", {}, 2);
            } else {
                if (this.player.getChild("CDPoster"))
                    this.player.removeChild("CDPoster");
            }
        },
        noPlayBtn: function (val) {
            if (val) {
                this.player.controlBar.removeChild("PlayToggle");
                this.player.addClass("no-play-btn");
            } else {
                this.player.controlBar.addChild("PlayToggle");
                this.player.removeClass("no-play-btn");
            }
        },
    },
    methods: {
        setSrc(newVal) {
            if (/[.]flv\b/i.test(newVal)) {
                this.player.src({
                    src: newVal,
                    type: "video/flv",
                });
            } else if (/[.]m3u8\b/i.test(newVal)) {
                this.player.src({
                    src: newVal,
                    type: "application/x-mpegURL",
                });
            } else {
                this.player.src(newVal);
            }
        },
    },
    mounted() {
        VideoJS.addLanguage("zh-CN", VideoJS_ZH);
        this.$refs.video.volume = this.volume;
        this.player = VideoJS(
            this.id,
            {
                techOrder: ["Html5", "Flvjs"],
                autoplay: this.playing,
                preload: this.preload ? "auto" : "none",
                poster: this.poster,
                width: this.$el.clientWidth, //this.width,
                height: this.height,
                language: "zh-CN",
                flvjs: {
                    mediaDataSource: {
                        isLive: false,
                        cors: true,
                        withCredentials: false,
                    },
                    config: {
                        enableStashBuffer: false,
                    },
                },
            },
            () => {
                if (this.src) {
                    if(this.playing || this.preload) {
                        this.setSrc(this.src);
                        if(this.playing) {
                            this.player.play();
                        }
                    } else {
                        this.needUpdateSrc = true;
                    }
                }
            }
        );

        this.player.on("ready", (event) => {
            this.player.volume(this.volume);
        });

        this.player.on("play", (event) => {
            this.$emit("play");
        });

        this.player.on("playing", (event) => {
            this.$emit("playing");
        });

        this.player.on("paused", (event) => {
            this.$emit("paused");
        });

        this.player.on("ended", (event) => {
            this.$emit("endend");
        });

        this.player.on("error", (event) => {
            var error = this.player.error();
            if(error && error.code == error.MEDIA_ERR_SRC_NOT_SUPPORTED) {
                this.$emit('unsupported');
            }
        });

        this.player.el().querySelector(".vjs-poster").addEventListener("click",  async () => {
            if(this.needUpdateSrc) {
                this.setSrc(this.src);
                await new Promise(setTimeout);
                this.src && this.player.play();
            }
        });

        this.player.el().querySelector(".vjs-big-play-button").addEventListener("click", async () => {
            if(this.needUpdateSrc) { 
                this.setSrc(this.src);
                await new Promise(setTimeout);
                this.src && this.player.play();
            }
        });

        if (this.noPlayBtn) {
            this.player.controlBar.removeChild("PlayToggle");
            this.player.addClass("no-play-btn");
        }
    },
    beforeDestroy() {
        this.player.dispose();
    },
};
</script>
<style>
@import "../../../node_modules/video.js/dist/video-js.css";

.video-js {
    width: 100%;
}
</style>
